import { Search, X, Loader2 } from "lucide-react";

function PopoverSearchInput({ q, setQ, searchRef, column }) {
  return (
    <div className="p-2 border-b border-[#E6E1D6] relative">
      <Search size={13} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#978D78]" />
      <input ref={searchRef} value={q} onChange={(e) => setQ(e.target.value)}
        placeholder="Pesquisar por código ou descrição..."
        data-testid={`field-${column}-search-input`}
        className="w-full pl-8 pr-8 py-1.5 text-sm border border-[#E6E1D6] rounded outline-none focus:border-[#0F1829]" />
      {q && (
        <button type="button" onClick={() => setQ("")}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[#978D78] hover:text-[#0F1829]">
          <X size={12} />
        </button>
      )}
    </div>
  );
}

function OptionList({ loading, opts, column, onPick }) {
  return (
    <div className="max-h-64 overflow-y-auto">
      {loading && (
        <div className="px-3 py-4 text-center text-xs text-[#6B7280]">
          <Loader2 size={14} className="inline animate-spin mr-1" /> A pesquisar...
        </div>
      )}
      {!loading && opts.length === 0 && (
        <div className="px-3 py-4 text-center text-xs text-[#6B7280]">Sem resultados.</div>
      )}
      {!loading && opts.map((o) => (
        <button key={`opt-${o.id}`} type="button" onClick={() => onPick(o)}
          data-testid={`field-${column}-opt-${o.id}`}
          className="w-full text-left px-3 py-1.5 text-sm hover:bg-[#F5F2EB] border-b border-[#F3F0E7] last:border-0 flex items-baseline gap-2">
          <span className="font-mono text-[11px] text-[#978D78] w-14 shrink-0">#{o.id}</span>
          <span className="flex-1 truncate">{o.label || <span className="text-[#9CA3AF]">—</span>}</span>
        </button>
      ))}
    </div>
  );
}

export default function FkPopover({ column, q, setQ, searchRef, loading, opts, onPick }) {
  return (
    <div data-testid={`field-${column}-popover`}
      className="absolute z-50 mt-1 right-0 w-96 bg-white border border-[#E6E1D6] rounded-md shadow-xl overflow-hidden">
      <PopoverSearchInput q={q} setQ={setQ} searchRef={searchRef} column={column} />
      <OptionList loading={loading} opts={opts} column={column} onPick={onPick} />
      <div className="px-3 py-1.5 bg-[#FAF8F2] border-t border-[#E6E1D6] text-[10px] text-[#978D78] uppercase tracking-[0.15em]">
        Até 25 resultados
      </div>
    </div>
  );
}
